import { render, staticRenderFns } from "./Errors.vue?vue&type=template&id=5fa9965a&scoped=true&"
import script from "./Errors.vue?vue&type=script&lang=js&"
export * from "./Errors.vue?vue&type=script&lang=js&"
import style0 from "./Errors.vue?vue&type=style&index=0&id=5fa9965a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa9965a",
  null
  
)

/* custom blocks */
import block0 from "./Errors.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "Errors.vue"
export default component.exports